const mediaItems = [
  {
    title: '韩漫推荐：今夏必看恋爱三部曲',
    type: '推荐视频',
    duration: '12:35',
    image: 'https://readdy.ai/api/search-image?query=Video%20thumbnail%20style%20Korean%20manhwa%20romance%20illustration%20with%20soft%20pink%20and%20coral%20tones%2C%20couple%20characters%20in%20modern%20setting%2C%20play%20button%20overlay%20aesthetic%2C%20clean%20editorial%20design%2C%20warm%20inviting%20atmosphere&width=800&height=500&seq=media-01&orientation=landscape',
  },
  {
    title: '画师专访：韩漫创作的幕后故事',
    type: '深度访谈',
    duration: '28:42',
    image: 'https://readdy.ai/api/search-image?query=Artist%20studio%20scene%20with%20digital%20drawing%20tablet%20displaying%20Korean%20manhwa%20style%20artwork%2C%20warm%20lighting%2C%20creative%20workspace%2C%20cream%20and%20terracotta%20tones%2C%20editorial%20photography%2C%20clean%20composition&width=800&height=500&seq=media-02&orientation=landscape',
  },
  {
    title: '新番导视：本周最值得追的连载',
    type: '每周速览',
    duration: '08:15',
    image: 'https://readdy.ai/api/search-image?query=Dynamic%20Korean%20manhwa%20comic%20panels%20arranged%20in%20grid%20layout%20with%20vibrant%20colors%2C%20various%20genres%20represented%2C%20coral%20and%20cream%20color%20palette%2C%20editorial%20magazine%20style%2C%20clean%20structured%20composition&width=800&height=500&seq=media-03&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            精彩预览
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            韩漫推荐视频与深度内容，带你从不同角度发现韩漫的魅力
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {mediaItems.map((item) => (
            <div
              key={item.title}
              className="group rounded-2xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-[16/10] overflow-hidden bg-background-100">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    (e.target as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <span className="w-14 h-14 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-2xl text-primary-500 group-hover:text-background-50 transition-colors ml-0.5"></i>
                  </span>
                </div>
                <span className="absolute bottom-3 right-3 px-2.5 py-1 rounded-lg bg-background-950/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4 md:p-5">
                <span className="text-xs text-primary-600 font-medium">{item.type}</span>
                <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-900 mt-1.5 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}